import { useEffect, useState } from "react";
import { Upload, Trash2, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { api, formatApiError, fileUrl } from "@/lib/api";
import { toast } from "sonner";

export default function DokumenAdmin() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [isPublic, setIsPublic] = useState(true);
  const [file, setFile] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = () => api.get("/documents").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!file) return;
    setSaving(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const uploadRes = await api.post(`/upload?is_public=${isPublic}`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      await api.post("/documents", { title, file_id: uploadRes.data.file_id, is_public: isPublic });
      toast.success("Dokumen dimuat naik");
      setOpen(false);
      setTitle(""); setFile(null);
      load();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  const remove = async (id) => {
    await api.delete(`/documents/${id}`);
    toast.success("Dokumen dipadam");
    load();
  };

  return (
    <div data-testid="admin-dokumen-page">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="font-display text-2xl font-bold text-piks-black">Dokumen</h1>
          <p className="text-sm text-piks-muted">Urus dokumen rasmi PPPS.</p>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button data-testid="add-document-btn" className="bg-piks-black hover:bg-piks-black/90"><Upload className="w-4 h-4 mr-1.5" /> Muat Naik Dokumen</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>Muat Naik Dokumen</DialogTitle></DialogHeader>
            <form onSubmit={submit} className="space-y-4">
              <div><Label>Tajuk Dokumen</Label><Input required data-testid="document-title-input" value={title} onChange={(e) => setTitle(e.target.value)} className="mt-1.5" /></div>
              <div>
                <Label>Fail</Label>
                <input type="file" required data-testid="document-file-input" onChange={(e) => setFile(e.target.files?.[0])} className="mt-1.5 block w-full text-sm" />
              </div>
              <div className="flex items-center justify-between p-3 rounded-lg bg-piks-ivory">
                <span className="text-sm">Boleh diakses oleh ahli</span>
                <Switch checked={isPublic} onCheckedChange={setIsPublic} data-testid="document-public-toggle" />
              </div>
              <Button type="submit" disabled={saving} data-testid="document-submit-btn" className="w-full bg-piks-black hover:bg-piks-black/90">{saving ? "Memuat naik..." : "Muat Naik"}</Button>
            </form>
          </DialogContent>
        </Dialog>
      </div>

      <div className="space-y-2">
        {items.map((d) => (
          <div key={d.id} className="p-4 rounded-lg bg-white border border-piks-border flex items-center justify-between" data-testid={`admin-document-${d.id}`}>
            <a href={fileUrl(d.file_id)} target="_blank" rel="noreferrer" className="flex items-center gap-2.5 text-sm text-piks-black hover:text-piks-red">
              <FileText className="w-4 h-4" /> {d.title} {d.is_public && <span className="text-[10px] text-emerald-700 bg-emerald-50 px-1.5 py-0.5 rounded">AWAM AHLI</span>}
            </a>
            <button onClick={() => remove(d.id)} data-testid={`delete-document-${d.id}`} className="text-piks-muted hover:text-piks-red"><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
